<template>
  <div>
    <v-dialog v-model="openModalPdf" persistent max-width="1100px">
      <v-card>
        <v-toolbar color="tertiary" flat>
          <v-toolbar-title class="text-h6">PDF</v-toolbar-title>
          <v-spacer/>
          <v-btn color="transparent" dark depressed fab x-small @click="toggleModalPdf(null)">
            <v-icon small>mdi-close-thick</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="px-0 pb-0">
          <v-container fluid>
            <object :data="urlPdf" type="application/pdf">
              <embed :src=" urlPdf" type="application/pdf">
            </object>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ModalPdf',
  computed: {
    ...mapState('app', ['openModalPdf', 'urlPdf']),
  },
  methods: {
    ...mapActions('app', ['toggleModalPdf']),
  },
};
</script>

<style lang="css">
object {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
embed {
  overflow: hidden;
}
</style>
